import {
    FILM_STATUS_APPROVED,
    FILM_STATUS_PENDING,
    FILM_STATUS_PROCESSED,
    FILM_STATUS_PUBLISHED,
    FILM_STATUS_REJECTED
} from '../constants/amateurFilms';
import {dt, t} from 'l10n';
import {formatVideoLength} from './media';

const moment = require('moment');

export function getMSLength(amateurFilm, writeHours = false) {
    let {length} = amateurFilm;

    return formatVideoLength(length, writeHours);
}

export function formatDate(filmAmateur, extended = false) {
    let date = filmAmateur.publish_date || filmAmateur.date;

    let format = t('MM/DD/YYYY');
    if (extended) {
        format = t('MM/DD/YYYY [at] HH:mm');
    }

    return moment(date).format(format)
}

export function formatCommentDate(filmAmateurComment, extended = false) {
    return moment(filmAmateurComment.date).format(t('MM/DD/YYYY [at] HH:mm'))
}

export function sortCallbackDate(f1, f2) {
    return moment(f1.publish_date || f1.date).unix() > moment(f2.publish_date || f2.date).unix() ? -1 : 1;
}

export function sortCallbackPopularity(f1, f2) {
    return f1.like_count > f2.like_count ? -1 : 1;
}

export function getStatus(amateurFilm) {
    switch (amateurFilm.status) {
        case FILM_STATUS_PENDING:
            return dt('amateur_film', 'Pending');

        case FILM_STATUS_PROCESSED:
            return dt('amateur_film', 'Processed');

        case FILM_STATUS_REJECTED:
            return dt('amateur_film', 'Rejected');

        case FILM_STATUS_PUBLISHED:
            return dt('amateur_film', 'Published');

        case FILM_STATUS_APPROVED:
            return dt('amateur_film', 'Approved');
    }

    return '';
}




// WEBPACK FOOTER //
// ./src/utils/amateurFilms.js